import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import {
  Button,
  DropdownSkeleton,
  FormGroup,
  FormLabel,
  TextInput,
  TextInputSkeleton
} from 'carbon-components-react';
import Add16 from '@carbon/icons-react/lib/add/16';
import Close16 from '@carbon/icons-react/lib/close/16';

import { ComboBox } from './ComboBox';
import { showNotification } from './notification/BaseNotification';
// import "../scss/weekSelector.scss";

const WeekSelectorModifyModal = ({
  modalVisible,
  handleModalVisibility,
  onElementSubmitted,
  selectableItems,
  selectedItem,
  selectedQuantity,
  renderWeek,
  editingDisabled
}) => {
  const [amount, setAmount] = useState(selectedQuantity);
  const [currWeek, setCurrWeek] = useState(selectedItem);
  const [addButtonDisabled, setAddButtonDisabled] = useState(true);

  useEffect(() => { setAmount(selectedQuantity); }, [selectedQuantity]);
  useEffect(() => { setCurrWeek(selectedItem); }, [selectedItem]);

  const onChangeSelectItem = () => {
    if ((amount <= 0) || (currWeek === null)) {
      showNotification.warning('Warning: Week is mandatory');
    } else {
      onElementSubmitted({ oldWeekNumber: selectedItem.weekNum, 
                           oldQuantity: selectedQuantity, 
                           oldWeekStart: selectedItem.weekStart, 
                           oldWeekFinish: selectedItem.weekFinish, 
                           weekNumber: currWeek.weekNum, 
                           quantity: amount });
    }
  };

  const onChangeComboBox = (selectedItemNew) => {
    if (selectedItemNew !== null) {
      if (selectedItemNew.weekNum !== selectedItem.weekNum) {
        setAddButtonDisabled(false);
      } else if (amount === selectedQuantity) {
        setAddButtonDisabled(true);
      }
    } else {
      setAddButtonDisabled(true);
    }
    setCurrWeek(selectedItemNew || null);
  };

  const onChangeTextInput = (event) => {
    if (event !== selectedQuantity.toString()) {
      setAddButtonDisabled(false);
    } else if (currWeek.weekNum === selectedItem.weekNum) {
      setAddButtonDisabled(true);
    }
    setAmount(event !== null ? Number(event) : null);
  };

  return (
    modalVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container modal-overflow-visible">
          
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading">Modify Week</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={() => handleModalVisibility()}
              iconDescription=""
            />
          </div> 

          <div className="bx--modal-content">
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup>
                  <FormLabel className="subTitle">Week number *</FormLabel>
                  {selectableItems == null ? (
                    <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        dropUp={false}
                        onChange={(name, sItem,) => onChangeComboBox(sItem)}
                        id="WeekNumber"
                        initialSelectedItem={selectedItem}
                        disabled={editingDisabled}
                        items={selectableItems || []}
                        itemToString={renderWeek}
                        placeholder="Select"
                      />
                  )}
                </FormGroup>
              </div>
              <div className="bx--col-lg-2 bx--col-md-4">
                <FormGroup>
                  <FormLabel className="subTitle">N&deg; of drill *</FormLabel>
                  {!amount ? (
                    <TextInputSkeleton hideLabel />
                    ) : (
                      <TextInput
                        id="drillNumber"
                        name="drillNumber"
                        placeholder="Number of drills"
                        value={amount}
                        onChange={(event) => onChangeTextInput(event.target.value)}
                        type="number"
                        min="1"
                        disabled={editingDisabled}
                      />
                  )}
                </FormGroup>
              </div>
              <div className="bx--col-lg-2 bx--col-md-4 addBtnPosition">
                <Button
                  onClick={onChangeSelectItem}
                  className="addBtnStyle"
                  renderIcon={Add16}
                  disabled={addButtonDisabled || editingDisabled}
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  );
};

WeekSelectorModifyModal.propTypes = {
  modalVisible: PropTypes.bool.isRequired,
  handleModalVisibility: PropTypes.func.isRequired,
  onElementSubmitted: PropTypes.func.isRequired,
  selectableItems: PropTypes.arrayOf(PropTypes.shape({
    quantity: PropTypes.number,
    weekNum: PropTypes.number,
    weekNumber: PropTypes.number,
    weekStart: PropTypes.string,
    weekFinish: PropTypes.string,
  })).isRequired,
  selectedItem: PropTypes.shape({
    quantity: PropTypes.number,
    weekNum: PropTypes.number,
    weekNumber: PropTypes.number,
    weekStart: PropTypes.string,
    weekFinish: PropTypes.string,
  }).isRequired,
  selectedQuantity: PropTypes.number.isRequired,
  renderWeek: PropTypes.func.isRequired,
  editingDisabled: PropTypes.bool.isRequired
};

export default WeekSelectorModifyModal;
